import {Centrifuge, UnauthorizedError} from 'centrifuge'
import EventBus from '@/utils/eventBus'
import {getWSSubscribeChatToken, getWSToken,getWSComChatChannel,getWSSubscribeComChatToken} from '@/api/websocket'
import i18n from '@/locales/i18n'
import {getAccessToken} from '@/utils/accessToken'
import { flushWebsocketDiagnostics, recordWebsocketDiagnostic } from '@/utils/websocketDiagnostics'
import { def_logo_url } from '@/settings'
const host = process.env.VUE_APP_WS_HOST
const RECONNECT_FAILURE_TIMEOUT = 20000

export async function getWSClientToken() {
  // 无登录态直接抛错，避免 Centrifuge 自动 token 刷新发出无 Authorization 的请求
  if (!getAccessToken()) {
    throw new UnauthorizedError('no access token, skip ws token refresh')
  }
  const token = await new Promise((resolve, reject) => {
    getWSToken()
      .then((response) => {
        let token = ''
        if (response && response.code === 0) {
          token = response.data
        }
        //reject({message: '你没有权限！'})
        resolve(token)
      })
      .catch((error) => {
        reject('')
      })
  })
  return token;
}

export async function subscribeChatChannel(channelParams) { // 订阅频道
  if (!getAccessToken()) {
    throw new UnauthorizedError('no access token, skip subscribe chat token')
  }
  const subToken = await new Promise((resolve, reject) => {
    let conversationUUId = getConversationId(channelParams.channel)
    getWSSubscribeChatToken({conversation_id: conversationUUId})
      .then((response) => {
        let token = ''
        if (response && response.code === 0) {
          token = response.data
        }
        // reject({message: '你没有权限！'})
        resolve(token)
      })
      .catch((error) => {
        reject('')
      })
  })
  return subToken
}


export async function getComChatChannel(comAgentKey) { // 获取公共智能体订阅频道
  if (!getAccessToken()) {
    throw new Error('no access token, skip get com chat channel')
  }
  const comAgentChannel = await new Promise((resolve, reject) => {
    getWSComChatChannel({com_agent_key: comAgentKey})
      .then((response) => {
        let channel = ''
        if (response && response.code === 0) {
          channel = response.data
        }
        // reject({message: '你没有权限！'})
        resolve(channel)
      })
      .catch((error) => {
        reject('')
      })
  })
  return comAgentChannel
}

export async function getSubscribeComChatToken(channelParams) { // 订阅公共智能体频道token
  if (!getAccessToken()) {
    throw new UnauthorizedError('no access token, skip subscribe com chat token')
  }
  const subToken = await new Promise((resolve, reject) => {
    getWSSubscribeComChatToken({channel:channelParams.channel })
      .then((response) => {
        let token = ''
        if (response && response.code === 0) {
          token = response.data
        }
        // reject({message: '你没有权限！'})
        resolve(token)
      })
      .catch((error) => {
        reject('')
      })
  })
  return subToken
}



export function getChatChannel(conversationUUId) {
  let appName = process.env.VUE_APP_SUBSCRIBE_APP_NAME
  let channel = appName + '-agent-chat-' + conversationUUId
  return channel
}

export function getConversationId(channel) {
  let appName = process.env.VUE_APP_SUBSCRIBE_APP_NAME
  let conversationUUId = channel.replace(appName + '-agent-chat-', '')
  return conversationUUId
}


export function getUserNotificationChannel(accessToken) {
  let appName = process.env.VUE_APP_SUBSCRIBE_APP_NAME
  let channel = `${appName}-user-notification-${accessToken}`
  return channel
}

// 客户端连接有4种状态：
/*
connect()– 连接到服务器
disconnect()- 与服务器断开连接
close()- 如果不再需要，请关闭客户端
send(data)- 向服务器发送异步消息
rpc(method, data)- 发送任意RPC并等待响应
disconnected 当一个新的客户端被创建时，它就有一个disconnected状态
connecting 要连接到服务器，connect()必须调用方法。调用connect后，Client移动到该connecting状态。
connected 如果客户端无法连接到服务器，它会尝试使用指数退避算法（具有完全抖动）创建连接。如果与服务器的连接成功，则状态变为connected。
closed closedSDK 中实现的状态，当不再需要客户端时，必须清理内部队列、线程执行器等资源。所有订阅都应在关闭时自动进入unsubscribed状态。进入某个closed状态后客户端就无法使用了。
*/
/*
订阅有3种状态：
unsubscribed 当创建新的订阅时，它具有一个unsubscribed状态。
subscribing 要启动订阅通道的实际过程，subscribe()应该调用 Subscription 实例的方法。调用 Subscription 后subscribe()进入subscribing状态。
subscribed 如果订阅频道不成功，则根据错误类型，订阅可以自动重新订阅（使用指数退避）或进入某个unsubscribed状态（出现非临时错误）。如果频道订阅成功，则状态变为subscribed
*/
// 协议 目前分为 系统SYS 通知 业务 Agent
const PROTOCOLS = {}
// 公共智能体
const ComAgent={
  COUNSELOR_OPTIMIZE:'COUNSELOR_OPTIMIZE',
  PROMPT_OPTIMIZE:'PROMPT_OPTIMIZE',
  AVATAR_IMG_BUILD:'AVATAR_IMG_BUILD',
}
// 应用私有协议（通过消息队列传递）
const websocket = {
  socketClient: null,//websocket client
  isInit: false, // 标记是否初始化
  heartbeat: new Date().getTime(), // 心跳时间 ，通过心跳时间刷新token
  vm: null, // 初始化 客户端的页面可以拿到页面的一些参数
  protocols: PROTOCOLS,
  comAgent:ComAgent,
  channelList: { },
  subscriptionFailureWatches: { },
  subscriptionWatchBindings: new WeakSet(),
  retryTimer: null,
  reconnectFailureTimer: null,
  hasConnectedOnce: false,
  reconnectFailureNotified: false,
  connectionAttemptCount: 0,
  connectionAttemptStartedAt: 0,
  expectedDisconnectReason: '',
  init(vm) {
    void flushWebsocketDiagnostics()
    if (!this.isInit) {
      this.isInit = true
      this.vm = vm
      this.contact()
    }
  },
  hasAccessToken() {
    // Match request.js and token refresh: stale Vuex state must not revive a logged-out client.
    return !!getAccessToken()
  },
  close(reason = 'manual_close') {
    this.expectedDisconnectReason = reason
    recordWebsocketDiagnostic('ws_client_close_requested', {
      cause: 'client_intentional_close',
      raw: { reason }
    })
    // console.log('11111')
    this.isInit = false
    this.clearReconnectFailureWatch()
    this.clearAllSubscriptionFailureWatches()
    this.hasConnectedOnce = false
    this.reconnectFailureNotified = false
    this.connectionAttemptStartedAt = 0
    if (this.socketClient) {
      this.socketClient.disconnect() //断开服务
      Object.keys(this.channelList).forEach(key => {
        const sub = this.channelList[key]
        if (!sub) return
        if (typeof this.socketClient.removeSubscription === 'function') {
          this.socketClient.removeSubscription(sub)
        } else {
          sub.unsubscribe()
        }
      });
      // console.log('22222')
      this.channelList= {}
    }
    if (this.retryTimer) {
      clearTimeout(this.retryTimer)
      this.retryTimer = null
    }
  },
  contact() {
    const self = this
    const token = getAccessToken()
    if (!token) {
      if (self.isInit) {
        this.recontact()
      }
      return false
    }
    if (this.retryTimer) {
      clearTimeout(this.retryTimer)
      this.retryTimer = null
    }
    if (this.socketClient) {
      if (this.socketClient.state === 'disconnected') {
        this.socketClient.connect()
      }
      return this.socketClient
    }
    let url = host + '/connection/websocket'

    this.socketClient = new Centrifuge(url,
      {
        getToken: getWSClientToken
      }
    )
    this.socketClient.on('connecting', function (ctx) {
      console.log('connecting', ctx)
      self.connectionAttemptCount += 1
      self.connectionAttemptStartedAt = Date.now()
      recordWebsocketDiagnostic('ws_connecting', {
        cause: ctx?.code === 0 ? 'connect_called' : 'transport_reconnecting',
        ws: {
          client_state: self.socketClient?.state || '',
          connection_attempt: self.connectionAttemptCount
        },
        raw: {
          connecting_code: ctx?.code ?? null,
          reason: ctx?.reason || ''
        }
      })
      if (ctx.code !== 0 && self.isInit && self.hasAccessToken()) {
        self.startReconnectFailureWatch()
      }
    })

    this.socketClient.on('connected', function (ctx) {
      console.log('connected', ctx)
      recordWebsocketDiagnostic('ws_connected', {
        cause: 'connected',
        ws: {
          client_state: self.socketClient?.state || 'connected',
          connection_attempt: self.connectionAttemptCount
        },
        timing: {
          connecting_at: self.connectionAttemptStartedAt ? new Date(self.connectionAttemptStartedAt).toISOString() : '',
          elapsed_ms: self.connectionAttemptStartedAt ? Date.now() - self.connectionAttemptStartedAt : null
        },
        raw: {
          connected_code: ctx?.code ?? null,
          reason: ctx?.reason || ''
        }
      })
      self.hasConnectedOnce = true
      self.clearReconnectFailureWatch()
      self.reconnectFailureNotified = false
      self.startConnectedSubscriptionFailureWatches()
      if (self.vm && self.vm.$store) {
        self.vm.$store.dispatch('user/startUserNotificationSubscribe')
      }
    })

    this.socketClient.on('disconnected', function (ctx) {
      console.log('disconnected', ctx)
      const expectedDisconnectReason = self.expectedDisconnectReason
      self.expectedDisconnectReason = ''
      const disconnectedCause = expectedDisconnectReason
        ? 'client_intentional_close'
        : (ctx?.reason === 'no pong' || ctx?.reason === 'no ping' ? 'heartbeat_timeout' : 'unexpected_disconnect')
      recordWebsocketDiagnostic('ws_disconnected', {
        cause: disconnectedCause,
        ws: {
          client_state: self.socketClient?.state || 'disconnected',
          connection_attempt: self.connectionAttemptCount
        },
        raw: {
          disconnected_code: ctx?.code ?? null,
          reason: ctx?.reason || '',
          expected_reason: expectedDisconnectReason
        }
      })
      if (self.vm && self.vm.$store) {
        self.vm.$store.dispatch('user/stopUserNotificationSubscribe')
      }
      if (['no pong', 'no ping', 'transport closed'].includes(ctx.reason) && self.isInit && self.hasAccessToken()) {
        self.startReconnectFailureWatch()
      }
      if (self.isInit && self.hasAccessToken() && ctx.reason === 'no pong') {
        // 处理重连逻辑
        self.handleReconnect();
      } else if (self.isInit && self.hasAccessToken()) {
        self.recontact()
      }
    })
    //error您还可以在客户端使用事件工作时侦听内部发生的所有错误（状态更改不会反映这些错误，例如，初始连接时发生的传输错误、重新连接期间的传输、连接令牌刷新相关错误等）
    this.socketClient.on('error', function (ctx) {
      console.log('错误重连')
      console.log(ctx)
      const errorCode = Number(ctx?.error?.code)
      const errorCause = errorCode === 1
        ? 'client_connect_timeout'
        : errorCode === 5 || errorCode === 6
          ? 'client_token_error'
          : 'transport_error'
      recordWebsocketDiagnostic('ws_transport_error', {
        cause: errorCause,
        ws: {
          client_state: self.socketClient?.state || '',
          connection_attempt: self.connectionAttemptCount
        },
        raw: {
          error_code: Number.isFinite(errorCode) ? errorCode : null,
          message: ctx?.error?.message || '',
          type: ctx?.error?.type || ''
        }
      })
      if (errorCode === 1) {
        if (self.isInit && self.hasAccessToken()) {
          self.startReconnectFailureWatch()
        }
        if (self.socketClient && self.socketClient.state !== 'disconnected') {
          self.socketClient.disconnect()
        }
        self.recontact()
      }
      console.log('client error', ctx)
      // token过期会自动重联

    })
    this.socketClient.connect()
    // client.disconnect(); // 断开服务
  },
  startReconnectFailureWatch() {
    // 首次连接和已建立连接后的重连都需要在超时后通知页面。
    if (this.reconnectFailureTimer || this.reconnectFailureNotified) return
    this.reconnectFailureTimer = setTimeout(() => {
      this.reconnectFailureTimer = null
      if (!this.isInit || !this.hasAccessToken() || !this.socketClient || this.socketClient.state === 'connected') {
        return
      }
      this.reconnectFailureNotified = true
      recordWebsocketDiagnostic('ws_reconnect_failed_20s', {
        cause: 'reconnect_timeout',
        severity: 'warning',
        confidence: 'client_observed',
        ws: {
          client_state: this.socketClient?.state || '',
          connection_attempt: this.connectionAttemptCount
        },
        timing: {
          failure_watch_ms: RECONNECT_FAILURE_TIMEOUT
        }
      })
      EventBus.emit('websocket-reconnect-failed', { scope: 'connection', reason: 'reconnect_timeout' })
    }, RECONNECT_FAILURE_TIMEOUT)
  },
  clearReconnectFailureWatch() {
    if (!this.reconnectFailureTimer) return
    clearTimeout(this.reconnectFailureTimer)
    this.reconnectFailureTimer = null
  },
  isChatSubscriptionChannel(channel) {
    const appName = process.env.VUE_APP_SUBSCRIBE_APP_NAME
    return Boolean(channel && appName && channel.indexOf(`${appName}-agent-chat-`) === 0)
  },
  isIntentionalSubscriptionEnd(ctx = {}) {
    const code = Number(ctx.code)
    const reason = String(ctx.reason || '').toLowerCase()
    return code === 0 || code === 2 || reason === 'unsubscribe called' || reason === 'client closed'
  },
  clearSubscriptionFailureWatch(channel, subscription) {
    if (!channel) return
    const watch = this.subscriptionFailureWatches[channel]
    if (!watch || (subscription && watch.subscription !== subscription)) return
    if (watch.timer) {
      clearTimeout(watch.timer)
    }
    delete this.subscriptionFailureWatches[channel]
  },
  clearAllSubscriptionFailureWatches() {
    Object.keys(this.subscriptionFailureWatches || {}).forEach(channel => {
      this.clearSubscriptionFailureWatch(channel)
    })
    this.subscriptionWatchBindings = new WeakSet()
  },
  startConnectedSubscriptionFailureWatches() {
    Object.keys(this.channelList || {}).forEach(channel => {
      const subscription = this.channelList[channel]
      if (!this.isChatSubscriptionChannel(channel) || !subscription ||
          subscription.state !== 'subscribing') {
        return
      }
      this.startSubscriptionFailureWatch(channel, subscription, 'subscription pending after connection')
    })
  },
  startSubscriptionFailureWatch(channel, subscription, reason = '', allowUnsubscribed = false) {
    if (!this.isChatSubscriptionChannel(channel) || !subscription ||
        !this.isInit || !this.hasAccessToken()) {
      return
    }

    const currentWatch = this.subscriptionFailureWatches[channel]
    if (currentWatch && currentWatch.subscription === subscription &&
        (currentWatch.timer || currentWatch.notified)) {
      return
    }
    if (currentWatch && currentWatch.subscription !== subscription) {
      this.clearSubscriptionFailureWatch(channel, currentWatch.subscription)
    }

    const watch = {
      subscription,
      reason,
      allowUnsubscribed,
      notified: false,
      timer: null
    }
    watch.timer = setTimeout(() => {
      watch.timer = null
      const currentSubscription = this.channelList && this.channelList[channel]
      const state = subscription.state
      const isStillExpected = currentSubscription === subscription &&
        this.isConnected() &&
        state !== 'subscribed' &&
        (state !== 'unsubscribed' || watch.allowUnsubscribed)

      if (!this.isInit || !this.hasAccessToken() || !isStillExpected) {
        this.clearSubscriptionFailureWatch(channel, subscription)
        return
      }

      watch.notified = true
      recordWebsocketDiagnostic('ws_subscription_failed_20s', {
        cause: 'subscription_timeout',
        severity: 'warning',
        confidence: 'client_observed',
        conversation_uuid: this.isChatSubscriptionChannel(channel) ? getConversationId(channel) : '',
        subscription: {
          channel,
          state,
          reason: watch.reason
        },
        timing: {
          failure_watch_ms: RECONNECT_FAILURE_TIMEOUT
        }
      })
      console.warn('[ws] chat subscription did not recover', {
        channel,
        state,
        reason: watch.reason
      })
      EventBus.emit('websocket-reconnect-failed', {
        scope: 'subscription',
        channel,
        reason: watch.reason
      })
    }, RECONNECT_FAILURE_TIMEOUT)
    this.subscriptionFailureWatches[channel] = watch
  },
  bindSubscriptionFailureWatch(channel, subscription) {
    if (!this.isChatSubscriptionChannel(channel) || !subscription ||
        this.subscriptionWatchBindings.has(subscription)) {
      return
    }

    this.subscriptionWatchBindings.add(subscription)
    subscription.on('subscribing', ctx => {
      recordWebsocketDiagnostic('chat_channel_subscribing', {
        cause: 'channel_subscribing',
        conversation_uuid: this.isChatSubscriptionChannel(channel) ? getConversationId(channel) : '',
        subscription: {
          channel,
          state: subscription.state,
          reason: ctx?.reason || ''
        }
      })
      if (!this.isConnected()) return
      this.startSubscriptionFailureWatch(channel, subscription, ctx?.reason || 'subscribing')
    })
    subscription.on('subscribed', ctx => {
      this.clearSubscriptionFailureWatch(channel, subscription)
      recordWebsocketDiagnostic('chat_channel_subscribed', {
        cause: 'channel_subscribed',
        conversation_uuid: this.isChatSubscriptionChannel(channel) ? getConversationId(channel) : '',
        subscription: {
          channel,
          state: subscription.state,
          recovered: Boolean(ctx?.recovered || ctx?.wasRecovering)
        }
      })
    })
    subscription.on('error', ctx => {
      recordWebsocketDiagnostic('chat_channel_error', {
        cause: 'subscription_error',
        conversation_uuid: this.isChatSubscriptionChannel(channel) ? getConversationId(channel) : '',
        subscription: {
          channel,
          state: subscription.state
        },
        raw: {
          error_code: ctx?.error?.code ?? null,
          message: ctx?.error?.message || '',
          type: ctx?.type || ''
        }
      })
      if (!this.isConnected()) return
      this.startSubscriptionFailureWatch(
        channel,
        subscription,
        ctx?.error?.message || ctx?.type || 'subscription error'
      )
    })
    subscription.on('unsubscribed', ctx => {
      recordWebsocketDiagnostic('chat_channel_unsubscribed', {
        cause: this.isIntentionalSubscriptionEnd(ctx) ? 'client_intentional_close' : 'unexpected_unsubscribe',
        conversation_uuid: this.isChatSubscriptionChannel(channel) ? getConversationId(channel) : '',
        subscription: {
          channel,
          state: subscription.state
        },
        raw: {
          code: ctx?.code ?? null,
          reason: ctx?.reason || ''
        }
      })
      if (this.isIntentionalSubscriptionEnd(ctx)) {
        this.clearSubscriptionFailureWatch(channel, subscription)
        return
      }
      const watch = this.subscriptionFailureWatches[channel]
      if (watch && watch.subscription === subscription) {
        watch.allowUnsubscribed = true
      }
      if (!this.isConnected()) return
      this.startSubscriptionFailureWatch(channel, subscription, ctx?.reason || 'unsubscribed', true)
    })
  },
  handleReconnect() {
    // 如果连接还在，先断开。这个断开属于客户端重连流程，不应误判为网络故障。
    if(this.socketClient){
      if (this.socketClient.state === 'connected') {
        this.expectedDisconnectReason = 'reconnect_restart'
        this.socketClient.disconnect();
      }

      // 重新连接
      this.socketClient.connect();
    }
  },
  // 断线重连
  recontact() {
    console.log('重连')
    if (!this.isInit || !this.hasAccessToken()) return
    if (this.retryTimer) {
      clearTimeout(this.retryTimer)
    }
    const self = this
    this.retryTimer = setTimeout(() => {
      self.retryTimer = null
      self.contact()
    }, 10000)
  },
  ensureClient(vm) {
    // A page may request a subscription before App/login has initialized the client.
    if (vm && (!this.vm || this.vm.$?.isUnmounted)) this.vm = vm
    if (!this.hasAccessToken()) return null
    if (!this.isInit && this.vm) {
      this.isInit = true
    }
    if (!this.isInit || !this.vm) {
      console.error('WebSocket客户端未初始化')
      return null
    }
    if (!this.socketClient) this.contact()
    return this.socketClient
  },
  ensureConnected(vm) {
    const client = this.ensureClient(vm)
    if (!client) return null
    if (!this.hasAccessToken()) return null
    if (client.state === 'disconnected') {
      client.connect()
    }
    return client
  },
  getOrCreateSubscription(channel, options, vm) {
    const client = this.ensureConnected(vm)
    if (!client || !channel) return null

    let sub = this.channelList && this.channelList[channel] ? this.channelList[channel] : null
    if (!sub && typeof client.getSubscription === 'function') {
      sub = client.getSubscription(channel)
    }
    if (!sub) {
      sub = client.newSubscription(channel, options)
    }
    this.channelList[channel] = sub
    return sub
  },
  newSubscribe(conversationUUId, vm) {
    if (!conversationUUId) return null
    let channel = getChatChannel(conversationUUId)
    const subscription = this.getOrCreateSubscription(channel, {
      getToken: subscribeChatChannel
    }, vm)
    this.bindSubscriptionFailureWatch(channel, subscription)
    return subscription
  },
  getCacheChannel(conversationUUId){
    let channel = getChatChannel(conversationUUId)
    let sub=null
    if(this.channelList&&this.channelList[channel]){
      sub=  this.channelList[channel]
    }
    if (sub && sub.state !== 'subscribed') {
      return null
    }
    return sub
  },
  // 主动退订并清理某个会话频道
  unsubscribeChannel(conversationUUId){
    if(!conversationUUId) return
    let channel = getChatChannel(conversationUUId)
    let sub = this.channelList ? this.channelList[channel] : null
    if(!sub) return
    this.clearSubscriptionFailureWatch(channel, sub)
    try{
      if (sub.state !== 'unsubscribed') {
        sub.unsubscribe()
      }
      if (this.socketClient && typeof this.socketClient.removeSubscription === 'function') {
        this.socketClient.removeSubscription(sub)
      }
    } catch(e){
      console.warn('[ws] unsubscribeChannel failed', channel, e)
    }
    this.subscriptionWatchBindings.delete(sub)
    delete this.channelList[channel]
  },
  newComAgentSubscribe(comAgentKey, callback, vm) {
    return getComChatChannel(comAgentKey)
      .then(channel => this.getOrCreateSubscription(channel, {
        getToken: getSubscribeComChatToken
      }, vm))
      .catch(() => null)
      .then(subscription => {
        if (typeof callback === 'function') callback(subscription)
        return subscription
      })
  },
  // 添加新的用户通知订阅方法
  newUserNotificationSubscribe(accessToken) {
    const self = this

    // 现有检查代码保持不变...
    if (!this.ensureConnected()) {
      console.error('WebSocket客户端未初始化')
      return null
    }

    let channel = getUserNotificationChannel(accessToken)

    if (this.channelList && this.channelList[channel]) {
      this.ensureConnected()
      return this.channelList[channel]
    }

    const createSub = () => {
      try {
        const sub = this.getOrCreateSubscription(channel, {
          getToken: getSubscribeComChatToken
        })
        if (!sub) return null

        // 设置事件监听
        sub.on('error', (ctx) => {
          console.error('用户通知频道订阅错误:', ctx)
          self.channelList[channel] = null
        })

        sub.on('publication', (ctx) => {
          const notificationData = ctx.data
          // 处理不同类型的通知
          self.handleUserNotification(notificationData)
        })

        return sub
      } catch (error) {
        console.error('创建用户通知订阅失败:', error)
        return null
      }
    }

    this.ensureConnected()
    return createSub()
  },

  /**
   * 处理用户通知
   */
  handleUserNotification(notificationData) {
    const { type } = notificationData

    // 根据通知类型分发全局事件
    if (type.startsWith('UB')) {
        this.vm.$store.dispatch('user/handleUserNotification', notificationData)
    } else if (type.startsWith('SA')) {
      switch (type) {
        case 'SA:agent_deleted':
          this.emitAgentDeletedEvent(notificationData)
          break
        case 'SA:document_deleted':  // 新增
          this.emitDocumentDeletedEvent(notificationData)
          break
        case 'SA:knowledge_deleted':   // 新增
          this.emitProjectDeletedEvent(notificationData)
          break
        default:
          console.log('未处理的SA通知类型:', type)
      }
    } else if (type.startsWith('PN')) {
      switch (type) {
        case 'PN:project_build':
          this.projectBuildEvent(notificationData)
          break
        case 'PN:pay_order':
          this.paymentCompletedEvent(notificationData)
          break
        default:
          console.log('平台推送通知:', type)
      }
    } else {
      console.log('未处理的通知类型:', type)
    }
  },

  /**
   * 发射智能体删除事件
   */
  emitAgentDeletedEvent(notificationData) {
    const eventData = {
      agentId: notificationData.agent_id,
      status:notificationData.status,
      originalData: notificationData
    }
    EventBus.emit('agent-deleted', eventData)
  },


  emitDocumentDeletedEvent(notificationData) {
    const eventData = {
      docId: notificationData.doc_id,
      knowledgeId: notificationData.knowledge_id,
      timestamp: notificationData.timestamp,
      originalData: notificationData
    }

    EventBus.emit('document-deleted', eventData)
  },

  emitProjectDeletedEvent(notificationData) {
    const eventData = {
      knowledgeId: notificationData.knowledge_id,
      timestamp: notificationData.timestamp,
      originalData: notificationData
    }

    EventBus.emit('project-deleted', eventData)
  },

  async projectBuildEvent(notificationData) {
    const eventData = {
      knowledgeId: notificationData.id,
      timestamp: notificationData.timestamp,
      originalData: notificationData
    }

    if ('Notification' in window) {
      const permission = await Notification.requestPermission()
      if (permission !== 'granted') {
        return
      }

      const buildSuccess = i18n.global.t('notification.build_success')
      const buildFailed = i18n.global.t('notification.build_failed')
      const buildVersion = i18n.global.t('notification.build_version')
      const clickToDetail = i18n.global.t('notification.click_to_detail')

      if (permission === 'granted') {
        const siteName = 'PAITEAMS'
        const logo = def_logo_url
        const res = eventData.originalData.status.includes('ready') ? buildSuccess : buildFailed
        const body = `${eventData.originalData.title}${buildVersion}${eventData.originalData.version_number}${res}, ${clickToDetail}`
        const url = new URL(window.location.href)
        const notificationTag = `conversation-${eventData.originalData.conversation_id || 'no'}-version-${eventData.originalData.version_number}`
        const options = {
          body: body,
          icon: logo,
          data: {
            url: url.origin + '/chat'
          },
          tag: notificationTag
        }
        const notification = new Notification(siteName, options)
        notification.onclick = (event) => {
          if (event.target.data && event.target.data.url) {
            window.open(event.target.data.url, '_blank')
          }
          notification.close()
        }
      }
    }
  },

  async paymentCompletedEvent(notificationData) {
    const eventData = {
      knowledgeId: notificationData.id,
      timestamp: notificationData.timestamp,
      originalData: notificationData
    }

    if ('Notification' in window) {
      const permission = await Notification.requestPermission()
      if (permission !== 'granted') {
        return
      }

      const orderData = eventData.originalData.order
      const orderStatus = orderData.order_status
      let statusInfo = ''
      if(orderStatus === 1){
        statusInfo = i18n.global.t('views.account_center.payment_success')
      }else if(orderStatus === 2){
        statusInfo = i18n.global.t('views.account_center.order_cancelled')
      }else{
        statusInfo = i18n.global.t('views.account_center.query_order_failed')
      }

      if (permission === 'granted') {
        const logo = def_logo_url
        const body = orderStatus === 1 ? i18n.global.t('views.account_center.thank_you') : ''
        const notificationTag = `order-status-${orderData.order_no || 'general'}`
        const options = {
          body: body,
          icon: logo,
          tag: notificationTag
        }
        const notification = new Notification(statusInfo, options)
        notification.onclick = (event) => {
          notification.close()
        }
      }
    }
  },

// 添加连接状态检查方法
  isConnected() {
    return this.socketClient && this.socketClient.state === 'connected'
  },

  getStateSnapshot(conversationUUId = '') {
    const channel = conversationUUId ? this.channelList?.[getChatChannel(conversationUUId)] : null
    return {
      client_state: this.socketClient?.state || 'uninitialized',
      channel_state: channel?.state || 'unsubscribed',
      connection_attempt: this.connectionAttemptCount,
      reconnect_failure_notified: this.reconnectFailureNotified
    }
  },

  // 添加等待连接方法
  waitForConnection(timeout = 10000) {
    return new Promise((resolve, reject) => {
      if (!this.socketClient) {
        reject(new Error('WebSocket客户端未初始化'))
        return
      }

      const startTime = Date.now()

      const checkConnection = () => {
        // 检查是否已连接
        if (this.isConnected()) {
          resolve(true)
          return
        }

        // 检查是否超时
        if (Date.now() - startTime > timeout) {
          reject(new Error(`WebSocket连接超时，当前状态: ${this.socketClient.state}`))
          return
        }

        // 继续检查
        setTimeout(checkConnection, 50)
      }
      checkConnection()
    })
  }
}

window.addEventListener('beforeunload', () => {
  websocket.close('page_unload')
})
export default websocket
